import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  menuPaper: {
    borderRadius: 8,
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
    marginTop: theme.spacing(1),
    minWidth: 180,
  },
  menuItem: ({ isActive }) => ({
    padding: theme.spacing(1.5, 2),
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    "&": {
      backgroundColor: isActive ? "#c2202b0b" : "transparent",
    },
    "& a": {
      textDecoration: "none",
      color: isActive ? "#C2202B" : theme.palette.text.primary,
      width: "100%",
      display: "block",
      fontSize: "14px",
    },
  }),
}));

const CollapsedSubMenuList = ({ anchorEl, onClose, items = [] }) => {
  const { pathname } = useLocation();
  const classes = useStyles(); // Global styles like menuPaper

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      classes={{ paper: classes.menuPaper }}
    >
      {items.map((item, index) => (
        <SubMenuItem
          key={`${index}-${item.name}`}
          item={item}
          onClose={onClose}
          isActive={pathname === item?.url}
        />
      ))}
    </Menu>
  );
};

const SubMenuItem = ({ item, onClose, isActive }) => {
  const classes = useStyles({ isActive });

  return (
    <MenuItem onClick={onClose} className={classes.menuItem}>
      <Link to={item?.url ?? "/"}>{item?.name ?? "Untitled"}</Link>
    </MenuItem>
  );
};

export default CollapsedSubMenuList;
